var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.centro[_vm.ident].status},[_c('p',[_vm._v(_vm._s(_vm.centro[_vm.ident].status))])])])}
var staticRenderFns = []

export { render, staticRenderFns }